module.exports = "/fonts/fa-brands-400.svg?073c2f3ce60eaf69cc2767ef3d989078";